export default {
  technicalTitle: 'Technical error',
  unavailableTitle: 'Sorry',
  unauthorizedTitle: 'Restricted access',
  technicalMessage: 'A technical error has occurred. We are sorry for any inconvenience this may cause you.',
  unavailableMessage: 'The service is unavailable. We are sorry for any inconvenience this may cause you.',
  unauthorizedMessage: 'We are sorry, you do not have access to this page.',
  tryLater: ' Please try again later.',
  retryButton: 'Retry',
  unauthorizedButton: 'Back to home page',
};
